import { useParams } from 'react-router-dom'
import { ComponentWithPermissions } from '../../../../../../../../baseComponents/CreateRoutering/types'
import DoubleTable from '../../../../../../../../baseComponents/DoubleTable'
import { useAddDoubleTableGreenRowRender } from '../../../../../../../../baseComponents/DoubleTable/functions'
import TitleAndWhiteBoxLayout from '../../../../../../../../baseComponents/Layout/TitleAndWhiteBoxLayout'
import { TwinTableLink } from '../../../../../../../../baseComponents/TwinTable'
import { ColumnTableSchema } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import locations from '../../../../../../../../utils/globals/locations'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { CustomerModelType } from '@teinor/erp/types/company/customer'
import SellInvoicesAccepted from './SellInvoicesAccepted'

interface GenerateMultiSellInvoicesRefundProps extends ComponentWithPermissions { }

const GenerateMultiSellInvoicesRefund: React.FC<GenerateMultiSellInvoicesRefundProps> = ({ userPermissions }) => {
    const { CustomerId } = useParams()

    return (<DoubleTable userPermissions={userPermissions} FirstChild={CustomersInner} SecondChild={SellInvoicesAccepted} displaySecond={CustomerId !== 'main'} />)
}

const CustomersInner = () => {
    const { t } = useTwinTranslation()
    return (
        <TitleAndWhiteBoxLayout title={t('generateInvoicesRefund', 'Generar devolución de facturas')}>
            <TableCustomersSellInvoice />
        </TitleAndWhiteBoxLayout>
    )
}

interface TableCustomersSellOrdersProps { }

const TableCustomersSellInvoice: React.FC<TableCustomersSellOrdersProps> = () => {
    const { t } = useTwinTranslation()
    const { CustomerId } = useParams()
    const { rowRenderer } = useAddDoubleTableGreenRowRender(CustomerId || '')
    const columns: ColumnTableSchema<CustomerModelType> = [
        {
            id: 'code',
            dataKey: 'code',
            label: t('code', 'Código'),
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('customerCode', 'Código de cliente') }
            },
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            },
        },
        {
            id: 'fiscal_name',
            dataKey: 'fiscal_name',
            label: t('fiscalName', 'Nombre Fiscal'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('fiscalName', 'Nombre Fiscal') }
            }
        },
        {
            id: 'surname',
            dataKey: 'surname',
            label: t('surname', 'Apellidos'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('surname', 'Apellidos') }
            },
        },
    ]
    return (
        <TwinTableLink name='generateMultiSellInvoicesRefundFromInvoice' createRowDataLink={[locations.sellInvoiceRefundMulti, ['$CustomerId']]} columns={columns} getDataFrom='/api/app/order/sell/sellInvoice/getAllCustomersWithAcceptedSellInvoice' extraWhereParams={{}} rowRenderer={rowRenderer} hideLoadFiltersButton={true} defaultOrder={{ defaultOrderField: 'CustomerId' }} />
    )
}


export default GenerateMultiSellInvoicesRefund